import React from 'react';

export default function SuggestionChips({ questions, onSuggest }) {
  if (!Array.isArray(questions) || !questions.length || typeof onSuggest !== 'function') return null;

  return (
    <div style={s.wrap}>
      {questions.map((q, i) => (
        <button key={i} type="button" onClick={() => onSuggest(q)} style={s.chip}>
          {q}
        </button>
      ))}
    </div>
  );
}

const s = {
  wrap: { display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 10 },
  chip: {
    padding: '6px 12px',
    borderRadius: 999,
    border: '1px solid var(--border-subtle)',
    background: 'transparent',
    color: 'var(--text-secondary)',
    fontSize: 12,
    cursor: 'pointer',
    fontFamily: 'var(--font-main)',
    transition: 'all 0.2s',
  },
};
